import { render, staticRenderFns } from "./Installation.vue?vue&type=template&id=3f834ba1&scoped=true"
import script from "./Installation.vue?vue&type=script&lang=js"
export * from "./Installation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f834ba1",
  null
  
)

export default component.exports